import { useState, useEffect } from 'react'

import profile from 'scripts/components/user/profile'

export const useProfile = () => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    profile
      .get()
      .then(response => setData(response))
      .catch(() => setData({}))
      .finally(() => setLoading(false))
  }, [])

  return { profile: data, loading: loading }
}
